<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 产品中心 -->
    <div class="div">
      <div class="across"></div>
      <div class="tabs">
        <div class="crumbs">
          <span>
            <!-- <router-link :to="{ path: '/' }"> -->
            <img src="../../assets/images/header/white.png" alt="logo" />
            首页
            <!-- </router-link> -->
          </span>
          &gt;
          <!-- @click="activeName = 'one'" style="cursor: pointer" -->
          <span>产品中心</span>
          &gt;
          <span>{{ text }}</span>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="大气专项" name="one">
            <div class="atmosphere">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/atmosphere/atmosphere.png" alt />
                </div>
                <div class="word">
                  大气环境管理系统包括：废气排口基础信息、自行监测、在线监测、空气站、微站、有毒有害气体监测、可燃气报警监测、预警预报等模块，通过动态数据与静态数据结合建立区域大气污染源清单（区域污染因子库）。系统能有效的对固定源排放、微站以及空气站数据进行联动分析、通过气象数据和扩散模型实现空气质量预警预报以及污染溯源。
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(1)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/atmosphere/atmosphere01.png" alt />
                    </div>
                    <div class="imgTitle">废气排口在线监控</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/atmosphere/atmosphere02.png" alt />
                    </div>
                    <div class="imgTitle">废气排放量统计</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="水专项" name="two">
            <div class="water">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/water/water.png" alt />
                </div>
                <div class="word">
                  水环境管理系统包括：排口基础信息、排口自行监测、排口在线监测、管网可视化、预警预报等5大模块，在“智慧管网”总体框架下，利用GIS技术建立区域1：1“源-管-厂-河流”可视化水环境图。系统包括生活污水管网图、雨水管网图、管道长度、管径、埋地深度、检修井、采样点、监测数据等信息，通过内置数据联动分析模型，对污水异常排放、超标排放、雨污混流情况等进行预警报警。
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(2)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/water/water01.png" alt />
                    </div>
                    <div class="imgTitle">废水排口在线监控</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/water/water02.png" alt />
                    </div>
                    <div class="imgTitle">在线监测废水排放量计算</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="固废专项" name="three">
            <div class="solidWaste">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste.png" alt />
                </div>
                <div class="word">
                  固废管理系统包括:一般固废和危险废物管理两大模块，系统以区域固废统计、转移调度为核心，通过对固废的产生、暂存、转运等全过程电子化跟踪，利用4G电子秤、视频监控等手段，实时掌握区域固废现状。系统能对区域固废进行分类统计，对超期存储、超量存储、产转异常进行自动预警报警，为区域中小企业集中转运、及时转运提供数据支撑，降低区域固废管理风险！
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(3)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste01.png" alt />
                    </div>
                    <div class="imgTitle">固废</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste02.png" alt />
                    </div>
                    <div class="imgTitle">危废暂存间</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="指挥调度" name="four">
            <div class="command">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/command/command.png" alt />
                </div>
                <div class="word">
                  指挥调度系统由智能报警和指挥调度两大模块组成，基于现场人员GPS定位、现场固定点视频监控、执法记录仪、手机音视频实时回传以及指挥中心其他应用系统提供的实时监控、应急物资储备等情况与指挥调度系统的紧密结合，辅助指挥人员及时、全方位了解突发事件周边环境情况、人员情况、处置情况、资源到位情况等，从而提高突发事件的处置效率。
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(4)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/command/command01.png" alt />
                    </div>
                    <div class="imgTitle">应急指挥</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/command/command02.png" alt />
                    </div>
                    <div class="imgTitle">视频监控</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="智慧管网" name="five">
            <div class="wisdom">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/water/water.png" alt />
                </div>
                <div class="word">
                  系统包括生活污水管网图、雨水管网图、管道长度、管径、埋地深度、检修井、采样点、监测数据等信息，通过内置数据联动分析模型，对污水异常排放、超标排放、雨污混流情况等进行预警报警。
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(5)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/water/water01.png" alt />
                    </div>
                    <div class="imgTitle">分布图</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/water/water02.png" alt />
                    </div>
                    <div class="imgTitle">排放统计</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="电力专项" name="six">
            <div class="electricity">
              <div class="introduce">
                <div>
                  <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste.png" alt />
                </div>
                <div class="word">
                  电力监控管理系统即分表计电系统，通过主要对生产设施、环保设施用电监控结合排口在线监测数据进行联动分析，为环保停限产、治理设施正常投用以及规范治理设施使用提供数据支撑，提高远程监管效率。通过监控充分发挥污染治理设施作用，提高污染治理设施运行效率，实时掌握污染治理设施运行情况，进一步提升生态环境质量。
                  <div class="interlinkage">
                    <!-- <div class="site">
                      链接地址：http://218.75.130.198:9530/
                    </div>-->
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(6)"
                    >点击跳转</el-button>
                  </div>
                </div>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1">部分功能展示</div>
                  <div class="assistant">FUNCTION DISPLAY</div>
                </div>
                <div class="mainbody">
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste01.png" alt />
                    </div>
                    <div class="imgTitle">用电监测</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste02.png" alt />
                    </div>
                    <div class="imgTitle">用电量统计</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="危废打印" name="seven">
            <div class="electricity">
              <div class="introduce">
                <!-- <div>
                  <img
                    src="../../assets/images/BusinessUnit/solidWaste/solidWaste.png"
                    alt=""
                  />
                </div>
                <div class="word">
                  电力监控管理系统即分表计电系统，通过主要对生产设施、环保设施用电监控结合排口在线监测数据进行联动分析，为环保停限产、治理设施正常投用以及规范治理设施使用提供数据支撑，提高远程监管效率。通过监控充分发挥污染治理设施作用，提高污染治理设施运行效率，实时掌握污染治理设施运行情况，进一步提升生态环境质量。
                  <div class="interlinkage">
                    
                    <el-button
                      type="primary"
                      round
                      style="position: absolute; bottom: 0; right: 0"
                      size="mini"
                      @click="to(6)"
                      >点击跳转</el-button
                    >
                  </div>
                </div>-->
                <video controls loop width="100%" height="100%">
                  <source src="../../assets/PrinterPromotion.mp4" type="video/mp4" />
                  <source src="movie.ogg" type="video/ogg" />您的浏览器不支持 video 标签。
                </video>
              </div>
              <div class="exhibition">
                <div class="title">
                  <div class="h1" style="color:#008CD7">危废标签专用打印机</div>
                  <!-- <div class="assistant">FUNCTION DISPLAY</div> -->
                </div>
                <div class="mainbody">
                  <div style="width:100%">
                    <p>《危险废物识别标志设置技术规范》（HJ1276-2022）将于在7月1日正式实施，对危废标签进行规范性管理，其中明确提出废标签内容需包含37位数字识别码和二维码等众多内容，并且每张标签的数字识别码和二维码都是唯一的，实现危废“一物一码”。</p>
                    <p>北京中泽宇华根据最新规范推出危废标签专用打印机，实现数字识别码、二维码、注意事项、联系人、重量等内容全自动生成，无需手写，解决企业标签打印难题。</p>
                    <p>手机小程序打印+电脑PC端打印，方便快捷！</p>

                    <h4>1、自动生成识别码、二维码，一键打印</h4>
                    <p>内置危废编码、注意事项、数字识别码、二维码等自动生成功能，按标签格式一键式生成危废标签打印，减少人员手工填写时间，让管理人员的时间用在更有价值的事务上。</p>

                    <h4>2、支持多种打印尺寸</h4>
                    <p>支持100*100mm，150*150mm，200*200mm，三种打印尺寸，满足不同尺寸打印需求。</p>

                    <h4>3、USB+蓝牙、随时随地打印</h4>
                    <p>实现PC、手机打印，随时打印，避免危废间因距离远无法连接网线打印的难题，2s打印出标签，即打即贴，方便快捷。</p>

                    <h4>4、及时预警、降低处罚风险</h4>
                    <p>危废超期存储、超量存储、产转异常自动预警报警，企业可通过手机、电脑实时查看、掌握企业危废情况，有效降低企业因环保管理不专业或不及时而被处罚风险。</p>

                    <h4>5、自动生成危废台账</h4>
                    <p>根据排污许可危废管理要求，一键自动生成企业产生、入库、出库危废台账，标准化管理，提高管理效率。</p>

                    <h4>6、一站式管理</h4>
                    <p>系统包括：固废间管理；危废管理；危废出入库管理；标签自动打印；我们同时提供打印机、不同型号危废标签，一站式解决企业危废管理，让企业危废管理省心、放心！</p>
                  </div>
                  <!-- <p>北京中泽宇华根据最新规范推出危废标签专用打印机，实现数字识别码、二维码、注意事项、联系人、重量等内容全自动生成，无需手写，解决企业标签打印难题。</p> -->

                  <!-- <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste01.png" alt />
                    </div>
                    <div class="imgTitle">用电监测</div>
                  </div>
                  <div>
                    <div class="imgs">
                      <img src="../../assets/images/BusinessUnit/solidWaste/solidWaste02.png" alt />
                    </div>
                    <div class="imgTitle">用电量统计</div>
                  </div>-->
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "one",
      text: "大气专项"
    };
  },

  created() {
    this.$store.state.menu = 2;
  },

  mounted() {
    this.query();
  },

  methods: {
    query() {
      if (this.$route.query.id != undefined) {
        this.activeName = this.$route.query.id;
      }
      // console.log(888, this.$route.query.id);
    },
    // 跳转页面
    to(e) {
      console.log(e);
      switch (e) {
        case 1:
          window.open("http://hjxxgk.com:9531/", "_blank");
          break;
        case 2:
          window.open("http://hjxxgk.com:9532/", "_blank");
          break;
        case 3:
          window.open("http://hjxxgk.com:9533/", "_blank");
          break;
        case 4:
          window.open("http://hjxxgk.com:9534/", "_blank");
          break;
        case 5:
          window.open("http://hjxxgk.com:9556/", "_blank");
          break;
        case 6:
          window.open("http://hjxxgk.com:9557/", "_blank");
          break;
      }
    }
  },
  watch: {
    activeName(news) {
      switch (news) {
        case "one":
          this.text = "大气专项";
          break;
        case "two":
          this.text = "水专项";
          break;
        case "three":
          this.text = "固废专项";
          break;
        case "four":
          this.text = "指挥调度";
          break;
        case "five":
          this.text = "智慧管网";
          break;
        case "six":
          this.text = "电力专项";
          break;
      }
    },
    $route(to) {
      switch (to.query.id) {
        case "one":
          this.activeName = "one";
          document.documentElement.scrollTop = 0;
          break;
        case "two":
          this.activeName = "two";
          document.documentElement.scrollTop = 0;
          break;
        case "three":
          this.activeName = "three";
          document.documentElement.scrollTop = 0;
          break;
        case "four":
          this.activeName = "four";
          document.documentElement.scrollTop = 0;
          break;
        case "five":
          this.activeName = "five";
          document.documentElement.scrollTop = 0;
          break;
        case "six":
          this.activeName = "six";
          document.documentElement.scrollTop = 0;
          break;
        case "seven":
          this.activeName = "seven";
          document.documentElement.scrollTop = 0;
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    width: 100%;
    padding-top: 100px;
    .across {
      width: 100%;
      height: 50px;
      background-color: #0064a1;
    }
    .tabs {
      position: relative;
      padding: 0 50px;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      margin-top: -45px;
      // 子页面样式
      .atmosphere,
      .water,
      .solidWaste,
      .command,
      .wisdom,
      .electricity {
        .introduce {
          margin: 70px 0;
          display: flex;
          > div:nth-child(1) {
            width: 40%;
            height: 24.3vh;
            overflow: hidden;
          }
          img {
            width: 100%;
            height: 100%;
            transition: 1.2s;
            -moz-transition: 1.2s; /* Firefox 4 */
            -webkit-transition: 1.2s; /* Safari 和 Chrome */
            -o-transition: 1.2s; /* Opera */
          }
          > div:nth-child(1):hover {
            width: 40%;
            height: 24.3vh;
            overflow: hidden;
            img {
              width: 110%;
              height: 110%;
              margin-left: -5%;
              margin-top: -5%;
              margin-bottom: -10%;
              transition: 1.2s;
              -moz-transition: 1.2s; /* Firefox 4 */
              -webkit-transition: 1.2s; /* Safari 和 Chrome */
              -o-transition: 1.2s; /* Opera */
            }
          }

          .word {
            position: relative;
            color: #666666;
            width: 60%;
            font-size: 16px;
            line-height: 1.5;
            text-indent: 2em;
            padding-left: 50px;
            .site {
              position: absolute;
              bottom: 0;
              right: 90px;
              line-height: 28px;
              font-size: 11px;
              font-family: Microsoft YaHei;
              color: #999999;
              text-align: justify;
            }
          }
        }
        .exhibition {
          margin: 70px 0;
          width: 100%;
          .title {
            .h1 {
              font-size: 28px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 37px;
              color: #333333;
            }
            .assistant {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 24px;
              color: #333333;
              padding-top: 10px;
            }
          }
          .mainbody {
            display: flex;
            justify-content: space-between;
            > div {
              width: 50%;
              // height: 28vh;
              .imgs {
                width: 100%;
                // height: 28vh;
                img {
                  width: 100%;
                  // height: 100%;
                }
              }
              p {
                text-indent: 2em;
              }

              // .imgs:hover {
              //   overflow: hidden;
              //   img {
              //     width: 110%;
              //     height: 110%;
              //     margin-left: -5%;
              //     margin-top: -5%;
              //     transition: 0.5s;
              //     -moz-transition: 0.5s; /* Firefox 4 */
              //     -webkit-transition: 0.5s; /* Safari 和 Chrome */
              //     -o-transition: 0.5s; /* Opera */
              //   }
              // }
              .imgTitle {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .crumbs {
    position: absolute;
    right: 50px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
